import axios from "axios";

const Axios = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}api`,
  withCredentials: true,
});

/**
 * Interceptor token dynamique
 */
Axios.interceptors.request.use((request) => {
  const jwt = localStorage.getItem("jwt"); // 🔥 token relu à chaque requête
  if (jwt) {
    request.headers.authorization = "Bearer " + jwt;
  }
  return request;
});

export default Axios;
